export default __webpack_public_path__ + "static/media/Text.72585d9c.svg";